// extracted by mini-css-extract-plugin
export default {"codeSelect":"styles_codeSelect__mCI6S","phoneNumberInput":"styles_phoneNumberInput__-SR0c"};